import { Box, Button, MenuItem, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import show from "../../api/public/storefronts/show";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import useStorefrontStore from "../../stores/public/useStorefrontStore";
import WushPopover from "../../components/layout/WushPopover";
import PageLoading from "../../components/layout/PageLoading";
import CartPopover from "../../components/displays/storeFront/CartPopover";
import { ExpandMore } from "@mui/icons-material";

export default function Storefront() {
  const [ forceClose, setForceClose ] = useState(false);
  const { organization_id } = useParams();
  let organizationDomain = window.location.hostname.split('.')[0];

  if(organizationDomain === 'ims' || organizationDomain === 'stage-ims' || organizationDomain === 'localhost') {
    organizationDomain = null;
  }

  const { organization, setOrganization, itemCategories, setItemCategories, setItems, itemsByCategoryId } = useStorefrontStore();

  const navigate = useNavigate();

  useEffect(() => {
    show((organizationDomain || organization_id), (response) => {
      setOrganization(response.organization);
      setItemCategories(response.item_categories);
      setItems(response.items);
    }, () => {
      setOrganization(null);
      navigate('/admin');
    });
  }, []);

  const handleItemClick = (item) => {
    setForceClose(true);
    setInterval(() => setForceClose(false), 100);
    navigate(`/storefront/${organization.id}/items/${item.id}`);
  };

  const handleLogoClick = () => {
    navigate(`/storefront/${organization.id}`);
  };

  if(!organization) return <PageLoading />;

  return (
    <Stack pb={8} bgcolor={organization.storefront_body_background_color} minHeight="100vh">
      <Stack textAlign="left">
        <Stack direction="row" py={5} bgcolor={organization.storefront_header_background_color} className="hide-print">
          <Stack direction="row" spacing={{xs: 2, sm: 8}} width="100%" px={{ xs: 2, sm: 10 }}>
            <Stack direction="row" spacing={{xs: 2, sm: 8}} width="85%" display={{ xs: 'none', sm: 'flex' }}>
              {organization.organization_logo_url ? <Stack sx={{ cursor: 'pointer' }} onClick={handleLogoClick}>
                <img src={organization.organization_logo_url} alt={organization.name} style={{ height: '100px' }} />
              </Stack>
              : <Stack onClick={handleLogoClick}>
                <Typography color={organization.storefront_header_font_color} variant="h3" sx={{ my: 'auto' }}>{organization.name}</Typography>
              </Stack>}
              {itemCategories.map((itemCategory) => itemsByCategoryId(itemCategory.id).length > 0 && (
                <Stack key={itemCategory.id} sx={{ my: 'auto !important' }}>
                  <WushPopover
                    forceClose={forceClose}
                    anchor={
                      <Button>
                        <Stack direction="row" spacing={2}>
                          <Typography color={organization.storefront_header_font_color} variant="body1" fontWeight="510">
                            {itemCategory.name}
                          </Typography>
                          <ExpandMore sx={{ my: "auto", color: organization.storefront_header_font_color }} />
                        </Stack>
                      </Button>
                    }
                  >
                    <Stack pr={2} py={2} spacing={2} my="auto">
                      {itemsByCategoryId(itemCategory.id).map((item) => (
                        <MenuItem
                          onClick={() => handleItemClick(item)}
                          key={item.id}
                          direction="row"
                          justifyContent="space-between"
                        >
                          <Stack direction="row" spacing={2}>
                            {item.image_url ? <img src={item.image_url} alt={item.name} style={{ height: '35px', width: '35px', borderRadius: '100px' }} /> : null}
                            <Typography sx={{ my: 'auto !important' }}>{item.name}</Typography>
                          </Stack>
                        </MenuItem>
                      ))}
                    </Stack>
                  </WushPopover>
                </Stack>
              ))}
              <Stack width="15%" textAlign="right" my="auto">
                <CartPopover />
              </Stack>
            </Stack>
            <Stack spacing={2} width="100%" direction="row" display={{ xs: 'flex', sm: 'none' }} flexWrap="wrap" justifyContent="center">
              {organization.organization_logo_url ? <Box textAlign="center" height="100px" width="100%" onClick={handleLogoClick}>
                <img src={organization.organization_logo_url} alt={organization.name} style={{ height: '100%' }} />
              </Box>
              : <Stack onClick={handleLogoClick}>
                <Typography color={organization.storefront_header_font_color} variant="h3" sx={{ my: 'auto' }}>{organization.name}</Typography>
              </Stack>}
              <WushPopover
                forceClose={forceClose}
                anchor={
                  <Button sx={{ my: "auto" }}>
                    <Stack direction="row" spacing={2}>
                      <Typography color={organization.storefront_header_font_color} variant="h5" fontWeight="510">
                        Menu
                      </Typography>
                      <ExpandMore sx={{ my: "auto", color: organization.storefront_header_font_color }} />
                    </Stack>
                  </Button>
                }
              >
                <Stack p={2}>
                  {itemCategories.map((itemCategory) => itemsByCategoryId(itemCategory.id).length > 0 && (
                    <Stack key={itemCategory.id} sx={{ my: 'auto !important' }}>
                      <WushPopover
                        forceClose={forceClose}
                        anchor={
                          <Button sx={{ textAlign: 'left' }}>
                            <Stack direction="row" spacing={2}>
                              <Typography color={organization.storefront_header_font_color} variant="h5" fontWeight="510">
                                {itemCategory.name}
                              </Typography>
                            </Stack>
                          </Button>
                        }
                      >
                        <Stack pr={2} py={2} spacing={2} my="auto">
                          {itemsByCategoryId(itemCategory.id).map((item) => (
                            <MenuItem
                              onClick={() => handleItemClick(item)}
                              key={item.id}
                              direction="row"
                              justifyContent="space-between"
                            >
                              <Stack direction="row" spacing={2}>
                                {item.image_url ? <img src={item.image_url} alt={item.name} style={{ height: '35px', width: '35px', borderRadius: '100px' }} /> : null}
                                <Typography sx={{ my: 'auto !important' }}>{item.name}</Typography>
                              </Stack>
                            </MenuItem>
                          ))}
                        </Stack>
                      </WushPopover>
                    </Stack>
                  ))}
                </Stack>
              </WushPopover>
              <Stack width="auto" textAlign="right" my="auto">
                <CartPopover />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
        <Stack pt={4} px={4}>
          <Stack>
            <Outlet />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}